import View from 'mixins/view';

const elements = {
  container: ".js-BubbleBox-Box.ui-BubbleBox-Box.social-share-widget",
  socialMediaList: '.share-options',
};

export default class extends View {
  constructor(model) {
    // Could accept Comment Model or Article Model
    super(model);
    this.setRootEl($(`
        <div class="js-BubbleBox-Holder box-inline">
            <!-- share widget -->
            <div class="js-BubbleBox-Box ui-BubbleBox-Box social-share-widget">
                <h3 class="social-share-widget--header">Udostępnij:</h3>
                <i class="icon-cross-size_2-color_lightgrey social-share-widget__close js-BubbleBox-Remove"></i>
                <ul class="share-options"></ul>
            </div>
        </div>
    `));
    this.title = encodeURIComponent(this.model.get('textContent'));
    const url = encodeURIComponent(model.get('url'));
    this.links = {
        facebook: `http://www.facebook.com/share.php?u=${ url }&title=${this.title}`,
        mail: `mailto:?body=${this.title} - ${ url }`,
        twitter: `http://twitter.com/intent/tweet?status=${this.title}+${ url }`,
        // google: `https://plus.google.com/share?url=${ url }`,
        wykop: `http://www.wykop.pl/dodaj/link/?url=${ url }&title=${this.title}`,
        linkedin: `http://www.linkedin.com/shareArticle?mini=true&url=${ url }&title=${this.title}`,
    };
  }
  bulkCommentShareTrigger() {
    const trigger = $(`<span class="js-BubbleBox-Call ui-BubbleBox-Call link-naked text-color_appblue box-inline shift-margin_2-right user-actions">Udostępnij</span>`);
    this.rootEl.prepend(trigger);
  }
  bulkArticleShareTrigger({ isHorizontal }) {
    const trigger = $(`<a href="#" target="_blank" title="" class="js-BubbleBox-Call"><i class="icon-size_3-more-color_lightgrey box-inline"><strong class="box-inline-full_width text-size_tiny shift-margin_2-top">WIĘCEJ</strong></i></a>`);

      this.rootEl
        .prepend(trigger)
        .removeClass('box-inline')
        .addClass('share-more text-align_center');

    if (isHorizontal) {
      this.rootEl
        .addClass('column-width_2');
    }
  }
  buildFacebookShareButton() {
    const button = $(`<li><a class="share-link share-link--facebook" href="#">Facebook</a></li>`);
    button.find('a')
      .on('click', (event) => {
        event.preventDefault();
        window.open(this.links.facebook, 'winname','directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=no,width=400,height=350');
      });
    return button;
  }
  buildEmailShareButton() {
    return $(`<li><a class="share-link share-link--email" href="${this.links.mail}">Email</a></li>`);
  }
  buildTwitterShareButton() {
    const button = $(`<li><a class="share-link share-link--twitter" href="#">Twitter</a></li>`);
    button.find('a')
      .on('click', (event) => {
        event.preventDefault();
        window.open(this.links.twitter, 'winname','directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=no,width=400,height=350');
      });
    return button;
  }
  // buildGoogleShareButton() {
  //   const button = $(`<li><a class="share-link share-link--google" href="#">Google +</a></li>`);
  //   button.find('a')
  //     .on('click', (event) => {
  //       event.preventDefault();
  //       window.open(this.links.google, 'winname','directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=no,width=400,height=350');
  //     });
  //   return button;
  // }
  buildWykopShareButton() {
    const button = $(`<li><a class="share-link share-link--wykop" href="#">Wykop</a></li>`);
    button.find('a')
      .on('click', (event) => {
        event.preventDefault();
        window.open(this.links.wykop, 'winname','directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=no,width=400,height=350');
      });
    return button;
  }
  buildLinkedinShareButton() {
    const button = $(`<li><a class="share-link share-link--linkedin" href="#">Linkedin</a></li>`);
    button.find('a')
      .on('click', (event) => {
        event.preventDefault();
        window.open(this.links.linkedin, 'winname','directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=no,width=400,height=350');
      });
    return button;
  }
  buildPrintButton() {
    const button = $(`<div class="print-action">
      <a href="#" class="share-link share-link--print">Drukuj</a>
    </div>`);

    button.find('a')
      .on('click', (event) => {
        event.preventDefault();
        window.print();
      });
    return button;
  }
  buildLinkInput() {
    return `<div class="social-share-widget__input">
      <label for="share-link">Link</label>
      <input type="url" name="share-link" id="share-link" value="${this.model.get('url')}" readonly>
    </div>`;
  }
  render({ showPrintButton } = {}) {
    const facebookBtn = this.buildFacebookShareButton();
    const emailBtn = this.buildEmailShareButton();
    const twitterBtn = this.buildTwitterShareButton();
    // const googleBtn = this.buildGoogleShareButton();
    const wykopBtn = this.buildWykopShareButton();
    const linkedinBtn = this.buildLinkedinShareButton();
    const container = this.rootEl
      .find(elements.container);

    const list = this.rootEl
      .find(elements.socialMediaList)
      .append([
        facebookBtn,
        emailBtn,
        twitterBtn,
        // googleBtn,
        wykopBtn,
        linkedinBtn,
      ]);

    if (showPrintButton) {
      const printBtn = this.buildPrintButton();
      container.append(printBtn);
    }

    const linkInput = this.buildLinkInput();
    container.append(linkInput);

  }
}



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/social-media-share-view.js